<template>
  <article class="media">
    <figure class="media-left">
      <p class="image">
        <img :src="imgSrc" width="200" />
      </p>
    </figure>
    <div class="media-content">
      <div class="content">
        <p class="name">
          <strong class="is-size-5">{{ name }} </strong>
          <EmailLink :email="email" />
          <br />
        </p>
        <p>
          <slot></slot>
        </p>
      </div>
    </div>
  </article>
</template>
<style scoped lang="scss">
.name {
  //margin-top: 0.5rem;
}
</style>
<script>
import md5 from "tiny-hashes/md5";
import EmailLink from "@/components/EmailLink.vue";

export default {
  components: {
    EmailLink
  },
  props: {
    image: String,
    name: String,
    email: String
  },
  computed: {
    imgSrc() {
      if (this.image) {
        return this.image;
      }

      const hash = md5(this.email.toLowerCase());

      return `https://www.gravatar.com/avatar/${hash}?s=128&d=identicon`;
    }
  }
};
</script>
